import { PuzzleStatusSelectOptions } from './PuzzleStatusSelectOptions';

export const PuzzleStatusesApprovedArtistSelectOptions = PuzzleStatusSelectOptions.filter(
  (option) => option.value !== 'new',
);
